export default __webpack_public_path__ + "static/media/9.5836eca7.png";